type SEND = 'input' | 'sending' | 'send' | 'error'

export interface LoginPasswordForgotState {
  send: SEND
}

export const defaultLoginPasswordForgotState: LoginPasswordForgotState = {
  send: 'input',
}
